<template>
  <div>
    <div class="bg"></div>
    <div id="home">
      <img style="width: 180px;" src="../assets/imgs/money.png"/>
      <h1>내 숨은 퇴직금<br/>1분 만에 확인하세요!</h1>
      <div class="btn" @click="next()">
        <img src="../assets/imgs/kakao_white.png"/>
        내 예상 퇴직금 확인하기
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  export default {
    name: 'Home',
    components: {

    },
    data() {
      return {

      }
    },
    methods:{
      next(){
        this.$router.push('/joinDate')
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{position: absolute;height: 100vh;display: flex;flex-direction: column;align-items: center;width: 100%;justify-content: center;text-align: center;}
  h1{color:#333333;font-size: 24px;line-height: 34px;}
  .btn{font-size:20px;display: flex;justify-content: center;background:#4873FF;margin-top:40px;align-items: center;padding:0 30px;height: 52px;border-radius: 26px;color:#ffffff;font-weight: bold;}
  .btn img{width: 22px;margin-right: 10px;}
  .bg{position: absolute;top:0;left:0;width: 100%;height:45vh;background-image: linear-gradient(to bottom,#DCE4FF,#ffffff);}
</style>
